export const CronExpData = [
  {
    id: 1,
    title: 'Every minute',
    code: '* * * * *',
    details: 'At every minute',
  },
  {
    id: 2,
    title: 'Every 15 minutes',
    code: '*/15 * * * *',
    details: 'At every 15th minute.',
  },
  {
    id: 3,
    title: 'Every 30 minutes',
    code: '*/30 * * * *',
    details: 'At every 30th minute.',
  },
  {
    id: 4,
    title: 'Every hour',
    code: '0 * * * *',
    details: 'Every hour at minute 0',
  },
  {
    id: 5,
    title: 'Every 2 hour',
    code: '0 */2 * * *',
    details: 'Every 2nd hour at minute 0',
  },
  {
    id: 6,
    title: 'Every 6 hour',
    code: '0 */6 * * *',
    details: 'Every 6th hour at minute 0',
  },
  {
    id: 7,
    title: 'Every 12 hour',
    code: '0 */12 * * *',
    details: 'Every 12th hour at minute 0',
  },
  {
    id: 8,
    title: 'Every day',
    code: '0 0 * * *',
    details: 'Everyday at 12:00 AM',
  },
  {
    id: 9,
    title: 'Every day at 1 am',
    code: '0 1 * * *',
    details: 'Every day at 1:00 AM',
  },
  {
    id: 10,
    title: 'Every day at 6 am',
    code: '0 6 * * *',
    details: 'Every day at 6:00 AM',
  },
  {
    id: 11,
    title: 'Every day at 10 am',
    code: '0 10 * * *',
    details: 'Every day at 10:00 AM',
  },
  {
    id: 12,
    title: 'Every day at 1 PM',
    code: '0 13 * * *',
    details: 'Every day at 1:00 PM',
  },
  {
    id: 13,
    title: 'Every day at 8 pm',
    code: '0 20 * * *',
    details: 'Every day at 8:00 PM',
  },
  {
    id: 14,
    title: 'Every day at 11 pm',
    code: '0 23 * * *',
    details: 'Every day at 11:00 PM',
  },
  {
    id: 15,
    title: 'Every Monday',
    code: '0 0 * * MON',
    details: 'At 12 AM, only on Monday',
  },
  {
    id: 16,
    title: 'Every Tuesday At 1:00 AM',
    code: '0 1 * * TUE',
    details: 'At 1:00 AM, only on Tuesday',
  },
  {
    id: 17,
    title: 'Every Wednesday at 12 PM',
    code: '0 12 * * WED',
    details: 'At 12:00 PM, only on Wednesday',
  },
  {
    id: 18,
    title: 'Every Thursday at 1 PM',
    code: '0 13 * * THU',
    details: 'At 01:00 PM, only on Thursday',
  },
  {
    id: 19,
    title: 'Every Friday at 6 PM',
    code: '0 18 * * FRI',
    details: 'At 6:00 PM, only on Friday',
  },
  {
    id: 20,
    title: 'Every Saturday at 9 PM',
    code: '0 21 * * SAT',
    details: 'At 9:00 PM, only on Saturday',
  },
  {
    id: 21,
    title: 'Every Sunday at 11 PM',
    code: '0 23 * * SUN',
    details: 'At 11:00 PM, only on Sunday',
  },
  {
    id: 22,
    title: 'From Monday to Friday',
    code: '0 0 * * 1-5',
    details: 'At 12:00 AM, Monday to Friday',
  },
  {
    id: 23,
    title: 'On Saturday and Sunday',
    code: '0 0 * * 6,0',
    details: 'At 12:00 AM, only on Saturday and Sunday',
  },
  {
    id: 24,
    title: 'Every month on day 1',
    code: '0 0 1 * *',
    details: 'At 12 AM, on day 1 of every month',
  },
  {
    id: 25,
    title: 'Every month on day 15',
    code: '0 0 15 * *',
    details: 'At 12 AM, on day 15 of every month',
  },
  {
    id: 26,
    title: 'Every 3rd month',
    code: '0 0 1 */3 *',
    details: 'At 12:00 AM, on day 1 of every 3rd month.',
  },
  {
    id: 27,
    title: 'Every 6th month',
    code: '0 0 1 */6 *',
    details: 'At 12:00 AM, on day 1 of every 6th month.',
  },
  {
    id: 28,
    title: 'Every year',
    code: '0 0 1 1 *',
    details: 'At 12:00 AM, only on 1st January.',
  },
]